import { IData } from '../../types';

/**
 * This is an example validation function you can pass to QueryBuilder in the
 * `validator` prop. It assumes that you want to validate groups, and has a no-op
 * for validating rules which you should replace with your own implementation.
 */
export const defaultValidator = (query: any) => {
    const result: IData = {};

    const validateRule = (rule: any) => {
        if (rule.validator && !rule.validator(rule)) {
            result[rule.id] = { valid: false, reasons: ['false'] };
        }
        else if (!(!!rule.value || rule.value.length > 0)) {
            result[rule.id] = { valid: false, reasons: ['empty'] };
        }
    };

    const validateGroup = (rg: any) => {
        const reasons: string[] = [];
        if (rg.rules.length === 0) {
            reasons.push('empty group');
        }

        if (rg.id) {
            if (reasons.length) {
                result[rg.id] = { valid: false, reasons };
            } else {
                result[rg.id] = true;
            }
        }
        rg.rules.forEach((r: any) => {
            if (typeof r === 'string') {
                // Validation for this case was done earlier
            } else if ('rules' in r) {
                validateGroup(r);
            } else {
                validateRule(r);
            }
        });
    };
    validateGroup(query);
    return result;
    // You can return the result object itself like above, or if you just
    // want the entire query to be marked invalid if _any_ rules/groups are
    // invalid, return a boolean like this:
    //   return Object.values(result).map(rv => (typeof rv !== 'boolean')).includes(true);
    // That will return `true` if no errors were found.
};
